import script from "./FrontofficeCollectivites.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrontofficeCollectivites.vue?vue&type=script&setup=true&lang=ts"

import "./FrontofficeCollectivites.vue?vue&type=style&index=0&id=774014a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774014a2"]])

export default __exports__